(() => {
  'use strict';
  function applyMainSiteLanguage() {
    const url = new URL(window.location.href);
    const requested = url.searchParams.get('sdp_lang');
    if (!['es', 'en'].includes(requested)) return;
    if (document.documentElement.dataset.sdpEntryLanguageHandled) return;
    document.documentElement.dataset.sdpEntryLanguageHandled = 'true';
    url.searchParams.delete('sdp_lang');
    const returnPath = url.pathname + url.search + url.hash;
    window.history.replaceState(window.history.state, '', returnPath);
    if (document.documentElement.lang.split('-')[0] === requested) return;
    const form = document.getElementById(requested === 'en' ? 'SdpEnglishLocaleForm' : 'SdpSpanishLocaleForm');
    if (!form || form.method.toLowerCase() !== 'post') return;
    const action = new URL(form.action, window.location.href);
    if (action.origin !== window.location.origin || !/\/localization\/?$/.test(action.pathname)) return;
    const language = form.querySelector('input[name="language_code"]');
    const returnTo = form.querySelector('input[name="return_to"]');
    if (!language || language.value !== requested || !returnTo || form.querySelector('input[name="country_code"]')) return;
    returnTo.value = returnPath;
    document.documentElement.dataset.sdpEntryLanguagePending = 'true';
    try { form.requestSubmit(); } catch {}
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', applyMainSiteLanguage, { once: true });
  } else {
    applyMainSiteLanguage();
  }
})();

